import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/index.vue";
import ExchangeView from "../views/exchange/index.vue";
import MiningView from "../views/mining/index.vue";
import EarningsView from "../views/earnings/index.vue";
import MeView from "../views/me/index.vue";
import NoticeView from "../views/notice/index.vue";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        meta: { name: "home", tab: true },
        component: HomeView,
      },
      {
        path: "exchange",
        name: "exchange",
        meta: { name: "exchange", tab: true },
        component: ExchangeView,
      },
      {
        path: "mining",
        name: "mining",
        meta: { name: "mining", tab: true },
        component: MiningView,
      },
      {
        path: "earnings",
        name: "earnings",
        meta: { name: "earnings", tab: true },
        component: EarningsView,
      },
      {
        path: "me",
        name: "me",
        meta: { name: "me", tab: true },
        component: MeView,
      },
      {
        path: "notice",
        name: "notice",
        meta: { name: "notice", tab: false },
        component: NoticeView,
      },
    ],
  },
];

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router;
